import {UserQueries} from '../../api/user'
import {basicActions} from './actions'
import {basicSelectors} from './selectors'

export const UserService = {
  actions: {...basicActions},
  selectors: {...basicSelectors},
  queries: UserQueries,
} as const
